import { useContext, useMemo, useState, useCallback } from 'react';
import { AuthContext } from '../components/Auth/AuthProvider';

export enum EmailVerificationStateEnum {
  PENDING = 'pending',
  SENDING_EMAIL = 'sending_email',
  EMAIL_SENT = 'email_sent',
  ERROR = 'error',
}

type EmailVerificationState =
  (typeof EmailVerificationStateEnum)[keyof typeof EmailVerificationStateEnum];

export default function useEmailVerification() {
  const [state, setState] = useState<EmailVerificationState>(
    EmailVerificationStateEnum.PENDING,
  );
  const { actions, user } = useContext(AuthContext);

  const emailVerificationRequired = useMemo(
    () => user && !user.email_verified,
    [user],
  );

  const isSendingVerificationEmail = useMemo(
    () => state === EmailVerificationStateEnum.SENDING_EMAIL,
    [state],
  );

  const sendVerificationEmail = useCallback(async () => {
    setState(EmailVerificationStateEnum.SENDING_EMAIL);

    try {
      const emailSent = await actions?.verifyEmail();
      setState(
        emailSent
          ? EmailVerificationStateEnum.EMAIL_SENT
          : EmailVerificationStateEnum.ERROR,
      );
    } catch (_) {
      setState(EmailVerificationStateEnum.ERROR);
    }
  }, [actions]);

  return {
    state,
    emailVerificationRequired,
    isSendingVerificationEmail,
    sendVerificationEmail,
  };
}
